import React from 'react';

import Button from 'components/Button';

import './styles.css';

const Buttons = ({submitting, submitForm}) => (
  <div className="buttons">
    <Button
      onClick={submitForm}
      blue={!submitting}
      isLoading={submitting}
      disabled={submitting}>
      Create offer
    </Button>
  </div>
);

export default Buttons;
